export const KEYWORDTUNINGLABELS = [
  "Cost Weightage",
  "Impressions Quality",
  "Competition Index",
  "Monthly Avg Search",
];
